// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import { __ } from '../../i18n/l10n';
import CrossCloseButton from '../../modules/grids/components/buttons/CrossCloseButton';
import theme from '../../styled-components/dark';
import RoundedButton from '../RoundedButton';

const ModalWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-repeat: no-repeat;

  ${() => {
    if (Target.__MOBILE__) {
      return css`
        background-size: cover;
        background-position: center;
      `;
    }
    return css`
      background-size: 140% auto;
      background-position: left 50% bottom 140%;
    `;
  }}

  ${({ img }) => {
    return css`
      background-image: url(${img});
    `;
  }}
`;

const ActionButton = styled(RoundedButton)`
  width: calc(100% - 1em);
  margin-bottom: 0.5em;
`;

const TermsText = styled.div`
  color: ${theme.RegisterModal.TermsText.color};
  font-style: italic;
  font-size: 0.8em;
  margin: 1em 0 2em 0;
`;

const CloseButton = styled(CrossCloseButton)`
  position: absolute;
  top: 0.5em;
  left: 0.2em;
  width: 1.5em;
  height: 1.5em;
  background-color: #000000aa;
  padding: 0.4em;
  border-radius: 1em;
  font-size: 1.3em;
`;

const Content = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(to bottom, transparent 0%, black 40%);
`;

type Props = {
  onClose?: (...params: unknown) => unknown;
  onRegisterButton?: (...params: unknown) => unknown;
  onConnectButton?: (...params: unknown) => unknown;
  displayTerms: boolean;
  img: string;
};

const RegisterDefaultModal = ({ img, onRegisterButton, onConnectButton, displayTerms, onClose }: Props) => (
  <ModalWrapper img={img}>
    {onClose && Target.__MOBILE__ ? <CloseButton onClick={onClose} /> : null}
    <Content>
      <ActionButton
        backgroundColor={theme.RegisterModal.RegisterButton.backgroundColor}
        color={theme.RegisterModal.RegisterButton.color}
        label={__('Sign-up')}
        onClick={onRegisterButton}
      />
      <ActionButton
        backgroundColor={theme.RegisterModal.ConnectButton.backgroundColor}
        color={theme.RegisterModal.ConnectButton.color}
        label={__('Sign-in')}
        onClick={onConnectButton}
      />
      {displayTerms ? <TermsText>*{__('You must wager your deposit in order to withdraw it')}</TermsText> : null}
    </Content>
  </ModalWrapper>
);

export default RegisterDefaultModal;
